// extracted by mini-css-extract-plugin
export default {"div":"ColorLetterBox_div__Irx-2"};